<template>
    <div class="image-container" ref="imageContainerRef" v-show="!isHidden">
        <!-- 定位容器 -->
        <div class="move-container">
            <FreeContainer :children="tpl.children"> </FreeContainer>
        </div>
    </div>
</template>

<script >
import { defineAsyncComponent, nextTick, ref } from 'vue-demi';
import { snapshot } from '../utils';
const FreeContainer = defineAsyncComponent(async () => Promise.resolve(require('@futuweb/fego-render')?.plugins.ComplexComp.Container.Free));
const __sfc_main = {};
__sfc_main.props = {
  tpl: {
    type: Object,
    default: () => ({})
  },
  isHidden: {
    type: Boolean,
    default: false
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const imageContainerRef = ref(null);
  const getShareImageData = async () => {
    // 等待 DOM 更新完成
    await nextTick();
    if (imageContainerRef.value) {
      const pic = await snapshot(imageContainerRef.value);
      return pic;
    }
    return undefined;
  };
  return Object.assign({
    imageContainerRef
  }, {
    getShareImageData
  });
};
__sfc_main.components = Object.assign({
  FreeContainer
}, __sfc_main.components);
export default __sfc_main;
</script>

<style lang="less" scoped>
.image-container {
    display: flex;

    .move-container {
        width: 100%;
        height: 100%;
        align-self: center;
    }
}
</style>
